import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

type BooleanValueProps = {
    value: boolean | null,
    renderOnTrue?: JSX.Element | string,
    renderOnFalse?: JSX.Element | string,
    renderOnNull?: JSX.Element | string,
}

const BooleanValue = ({ value, renderOnTrue, renderOnFalse, renderOnNull }: BooleanValueProps): JSX.Element => {
    const { t } = useTranslation('common');
    let render;

    if (value === true) {
        render = renderOnTrue ?? t('data.bool.true');
    } else if (value === false) {
        render = renderOnFalse ?? t('data.bool.false');
    } else {
        render = renderOnNull ?? t('data.bool.null');
    }

    return <Fragment>{render}</Fragment>;
};

export default BooleanValue;
